export const icons = {
  account: {
    light: require('./accounts.svg'),
    dark: require('./dark/accounts.svg'),
  },
  import: {
    light: require('./import.svg'),
    dark: require('./dark/import.svg'),
  },
  trades: {
    light: require('./trades.svg'),
    dark: require('./dark/trades.svg'),
  },
  logHistory: {
    light: require('./log-history.svg'),
    dark: require('./dark/log-history.svg'),
  },
  dropFile: {
    light: require('./drop.svg'),
    dark: require('./dark/drop.svg'),
  },
  uploadFile: {
    light: require('./uploadFile.svg'),
    dark: require('./dark/uploadFile.svg'),
  },
} as const
